import {connect} from 'react-redux';
import GroupDeleteView from '../../components/views/mx/GroupDeleteView';
import * as GroupActions from '../../actions/mx/GroupActions';
import {State} from '../../../types/mx/reducers';
import {GroupDeleteStateProps, GroupDeleteDispatchProps} from '../../types/mx/containers';
import * as ModalActions from '../../../../wizard/actions/ModalActions';
import {AnyAction, Dispatch} from 'redux';

const mapStateToProps = (state: State, ownProps): GroupDeleteStateProps => {
    const {groupId, name} =
        state.group.form;

    const isSuccess =  (ownProps.data && ownProps.data.isSuccess) ? ownProps.data.isSuccess : false;

    return {
        isSuccess,
        group: {id: groupId, value: name, payload: ''}
    };
};

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>): GroupDeleteDispatchProps => {
    return {
        onPressDeleteConfirm: () => {
            dispatch(GroupActions.GROUP_DELETE_REQUEST_ACTION.action());
        },
        onPressClose: () => {
            dispatch(ModalActions.CLOSE_MODAL_ACTION.action());
        }
    };
};

const GroupDeleteContainer = connect(
    mapStateToProps, mapDispatchToProps
)(GroupDeleteView);

export default GroupDeleteContainer;